import ProjectStagesConfigContent from './ProjectStagesConfigContent'

export default ProjectStagesConfigContent
